import { useState } from 'react';
import type { SeksjonContext } from '../types';

export function useNavigation(planId: string) {
    const [context, setContext] = useState<SeksjonContext>({
        type: 'plan',
        planId,
    });
    return { context, setContext };
}
